import { activePaymentMethods } from "utils";

export const PAYMENT_OPTION_DEFINITIONS = [
	{
		id: activePaymentMethods.ecocashUsd.name,
		apiKey: "Ecocash USD",
		label: activePaymentMethods.ecocashUsd.label,
		icon: "ecocash",
		processingTime: "2-3 mins",
		description: "Pay with EcoCash USD wallet",
		iconBg: "bg-green-50",
		recommended: false,
	},
	{
		id: activePaymentMethods.ecocashZwl.name,
		apiKey: "Ecocash",
		label: activePaymentMethods.ecocashZwl.label,
		icon: "ecocash",
		processingTime: "2-3 mins",
		description: "Pay with EcoCash ZWL wallet",
		iconBg: "bg-green-50",
		recommended: true,
	},
	{
		id: activePaymentMethods.paypal.name,
		apiKey: "PayPal",
		label: activePaymentMethods.paypal.label,
		icon: "paypal",
		processingTime: "Instant",
		description: "Secure payment via PayPal",
		iconBg: "bg-akgreen/10",
		recommended: true,
	},
	{
		id: activePaymentMethods.stars.name,
		apiKey: "Stars Redemption",
		label: activePaymentMethods.stars.label,
		icon: "stars",
		processingTime: "Instant",
		description: "Use your Akello Smart Learning stars",
		iconBg: "bg-yellow-50",
		recommended: false,
	},
	{
		id: activePaymentMethods.voucher.name,
		apiKey: "Voucher",
		label: activePaymentMethods.voucher.label,
		icon: "voucher",
		processingTime: "Instant",
		description: "Redeem a prepaid voucher code",
		iconBg: "bg-purple-50",
		recommended: false,
	},
];

const storeMethodToApiKeyMap = PAYMENT_OPTION_DEFINITIONS.reduce((map, option) => {
	map[option.id] = option.apiKey;
	return map;
}, {});

export const mapStoreMethodToApiKey = (storeMethod) => storeMethodToApiKeyMap[storeMethod] || storeMethod;

export const mapApiKeyToStoreMethod = (apiKey) => {
	const option = PAYMENT_OPTION_DEFINITIONS.find((item) => item.apiKey === apiKey);
	return option?.id || apiKey;
};

const getAvailabilityForOption = (option, availabilityMap) => {
	const availability = availabilityMap?.[option.apiKey];

	return {
		enabled: availability?.enabled !== false,
		disabledMessage: availability?.message || null,
	};
};

export const getPaymentOptionsForCurrency = (currency, availabilityMap = {}) => {
    const currencyOptions = PAYMENT_OPTION_DEFINITIONS.filter((option) => {
        const config = availabilityMap[option.apiKey];
        return Array.isArray(config?.supported_currencies) && config.supported_currencies.includes(currency);
    }).map((option) => ({
        ...option, paymentMethod: option.id,
        label: availabilityMap[option.apiKey]?.label || option.label,
        ...getAvailabilityForOption(option, availabilityMap),
    }));
    return { allOptions: currencyOptions, enabledOptions: currencyOptions.filter((option) => option.enabled), disabledOptions: currencyOptions.filter((option) => !option.enabled) };
};

export const buildDefaultAvailabilityMap = () =>
	PAYMENT_OPTION_DEFINITIONS.reduce((map, option) => {
		map[option.apiKey] = {
			enabled: false,
			message: null,
			label: option.label,
            supported_currencies: [],
		};
		return map;
	}, {});
